<form [formGroup]="searchForm">
  <div class="content-block bg-gray-light">
    <div class="row">
      <div class="col-sm-10">
        <div
          class="mt-3 mb-2"
          sc-placeholder
          name="ab-page-title"
          [rendering]="rendering"
        ></div>
      </div>
    </div>
    <div class="row">
      <!-- Search Form -->
      <div class="col-xl-9">
        <div class="row narrow">
          <div class="form-group col-md-6 col-xl-4">
            <label *scText="formFields.fields.fromDate.label"></label>
            <div
              class="ab-datepicker"
              [ngClass]="{
                'ng-dirty': fromDateField.dirty,
                'ng-invalid': fromDateField.errors,
                'ng-touched': fromDateField.touched
              }"
            >
              <div class="flex-grow-1">
                <input
                  class="form-control"
                  abDateFormatter
                  [matDatepicker]="picker1"
                  [min]="fromDateMin"
                  [max]="fromDateMax"
                  [placeholder]="formFields.fields.fromDate.placeholder"
                  formControlName="fromDate"
                  maxlength="80"
                  required
                />
              </div>
              <button class="btn btn-default" (click)="picker1.open()">
                <i class="icon-calendar"></i>
              </button>
              <mat-datepicker #picker1></mat-datepicker>
            </div>
            <ng-container *ngIf="formFields.fields.fromDate.helpText">
              <div
                class="input-help-text small"
                *scRichText="formFields.fields.fromDate.helpText"
              ></div>
            </ng-container>
            <span
              class="field-validation-error"
              *ngIf="fromDateField.errors?.required"
              >{{ formFields.genericErrors.required.message }}
            </span>
            <span
              class="field-validation-error"
              *ngIf="
                fromDateField.errors?.matDatepickerMin ||
                fromDateField.errors?.matDatepickerMax
              "
              >{{ formFields.genericErrors.validationDateRange.message }}
            </span>
          </div>

          <div class="form-group col-md-6 col-xl-4">
            <label *scText="formFields.fields.toDate.label"></label>
            <div
              class="ab-datepicker"
              [ngClass]="{
                'ng-dirty': toDateField.dirty,
                'ng-invalid': toDateField.errors,
                'ng-touched': toDateField.touched
              }"
            >
              <div class="flex-grow-1">
                <input
                  class="form-control"
                  abDateFormatter
                  [matDatepicker]="picker2"
                  [min]="toDateMin"
                  [max]="toDateMax"
                  [placeholder]="formFields.fields.toDate.placeholder"
                  formControlName="toDate"
                  maxlength="80"
                  required
                />
              </div>
              <button class="btn btn-default" (click)="picker2.open()">
                <i class="icon-calendar"></i>
              </button>
              <mat-datepicker #picker2></mat-datepicker>
            </div>
            <ng-container *ngIf="formFields.fields.toDate.helpText">
              <div
                class="input-help-text small"
                *scRichText="formFields.fields.toDate.helpText"
              ></div>
            </ng-container>
            <span
              class="field-validation-error"
              *ngIf="toDateField.errors?.required"
              >{{ formFields.genericErrors.required.message }}
            </span>
            <span
              class="field-validation-error"
              *ngIf="toDateField.errors?.matDatepickerMin"
              >{{ formFields.genericErrors.validationInvalidMinToDate.message }}
            </span>
            <span
              class="field-validation-error"
              *ngIf="toDateField.errors?.matDatepickerMax"
              >{{ formFields.genericErrors.validationDateRange.message }}
            </span>
          </div>

          <div class="form-group col-6 col-xl-3">
            <label *scText="formFields.fields.select.label"></label>
            <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
              <mat-select formControlName="selectedReportType">
                <mat-option
                  *ngFor="let card of formFields.fields.select.values"
                  [value]="card.fields.Value.value"
                >
                  {{ card.fields.Label.value }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-2 col-xl-1">
            <label>&nbsp;</label>
            <button
              (click)="onSubmit()"
              class="btn btn-primary btn-step btn-submit"
              *scText="rendering.fields.submitButtonText"
              [disabled]="searchForm.invalid"
            ></button>
          </div>
        </div>
      </div>

      <!-- Download Form -->
      <div class="col-xl-3">
        <div class="row narrow">
          <div class="col-sm-7">
            <label *scText="formFields.fields.selectFormat.label"></label>
            <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
              <mat-select
                formControlName="selectedReportFormat"
                [placeholder]="formFields.fields.selectFormat.defaultValue"
              >
                <mat-option
                  *ngFor="let card of formFields.fields.selectFormat.values"
                  [value]="card.fields.Value.value"
                >
                  {{ card.fields.Label.value }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-sm-3 col-4">
            <label class="d-none d-sm-inline-block">&nbsp;</label>
            <button
              class="btn btn-submit btn-primary btn-step"
              *scText="rendering.fields.extraButtonText"
              (click)="download()"
              [disabled]="searchForm.invalid"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div
          class="audit-report-tables"
          sc-placeholder
          name="ab-audit-report-tables"
          [rendering]="rendering"
        ></div>
      </div>
    </div>
    <ab-loader [showLoader]="isFileDownloading"></ab-loader>
    <div *ngIf="isLoading" class="loader-bar"></div>
    <div *ngIf="showNoFound && !isLoading">
      <span class="text-no-found" *scText="noFound.fields.label"></span>
    </div>
  </div>
</form>
